import React, { useEffect } from 'react';
import { useProductRecommendations } from '../../integrations/relewise/hooks/useProductRecommendations';
import { RecommendedProductsCarousel } from '../../shared/components/recommended-products-carousel/recommended-products-carousel';
import { useLazyLoading } from '../../shared/hooks/useLazyLoading';
import { PdpRecommendedProductsData } from './cus-pdp-recommended-products.data';
import { ICusPdpRecommendedProductsProps } from './cus-pdp-recommended-products.props.autogenerated';

const PRODUCT_PAGE_TYPE = 'product';

const PdpRecommendedProducts = (props: ICusPdpRecommendedProductsProps<PdpRecommendedProductsData>) => {
    const { context, config, resources, data } = props;
    const { recommendationType, productCount, title, relevanceModifier, relevanceModifierStrength } = config;

    const pageType = context.request.urlTokens.pageType?.toLowerCase();
    const isInPdp = pageType === PRODUCT_PAGE_TYPE;
    const masterProductItemId = data.product.result?.ItemId;

    useEffect(
        function showErrorWhenNotInPdp() {
            if (!isInPdp) {
                console.error('"PDP Recommended products" module can only be used on product pages.');
            }
        },
        [isInPdp]
    );

    const { ref, isInView } = useLazyLoading();
    const { products, isLoading } = useProductRecommendations({
        productCount,
        recommendationType,
        isEnabled: isInPdp && !!masterProductItemId && isInView,
        displayLocation: 'pdp',
        masterProductItemId,
        relevanceModifier,
        relevanceModifierStrength
    });

    return (
        <RecommendedProductsCarousel
            products={products}
            title={title}
            context={context}
            ctaLabel={resources.recommendedProductsCtaLabel}
            ref={ref}
            isLoading={!isInView || isLoading}
        />
    );
};

export default PdpRecommendedProducts;
